import { render, staticRenderFns } from "./TituloPeriodoLetivo.vue?vue&type=template&id=53eef919&"
import script from "./TituloPeriodoLetivo.vue?vue&type=script&lang=js&"
export * from "./TituloPeriodoLetivo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports